import { connect } from "react-redux";

var Glyphicon = require("components/utility/icons/Glyphicon");
var ReadingLevelFormat = require("lib/academic/ReadingLevelFormat");
var CurrentUser = require("lib/account/CurrentUser");
var DropDownOptions = require("components/utility/DropDownOptions");
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingLevelIcon = require("components/reading/reading_levels/ReadingLevelIcon");
var RosterSelectors = require("lib/selectors/RosterSelectors");

@connect(
	(state, props) => {
		//if the studentReadingLevel is not passed in, grab from redux state.
		if (!props.studentReadingLevel && props.userID) {
			var student = RosterSelectors.student({ state, id: props.userID })
			var studentReadingLevel = student && student.current_reading_level ? student.current_reading_level : 0;
		}
		return {
			format: CurrentUser.get().prefs.reading_level_format,
			studentReadingLevel: props.studentReadingLevel || studentReadingLevel,
		}},
	(dispatch, props) => ({
		updateBook: (lexileScore) => {
			var user = CurrentUser.get()
			var overrideData = {
				instance_id: props.book.text_id,
				instance_type: "book",
				attribute_name: "lexile_score",
				value: lexileScore,
				user_id: user.id,
				user_role: user.role,
			}
			var bookUpdate = { lexile_score: lexileScore } 
			dispatch(ReadingActions.createOverrideUpdateBook({
				override: overrideData, update: bookUpdate }));
		}
	})
)

class ReadingLevelDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {edit: false}
	}
	triggerEdit(e) {
		$wr.nope(e)
		this.setState({edit: !this.state.edit})
	}
	handleChange(event) {
		var lexileScore = parseInt(this.refs.lexile.value)
		this.setState({edit: false})
		if (lexileScore != -1) {
			this.props.updateBook(lexileScore);
		}
	}

	renderCellDisplay() {
		if (this.props.lexile != undefined && this.props.lexile != null) {
			var level = ReadingLevelFormat.getScoreForFormat(this.props.lexile, this.props.format)
		} else {
			var level = "-"
		}
		if (this.props.showReadingLevelIcon) {
			var icon = (
				<ReadingLevelIcon studentReadingLevel={ this.props.studentReadingLevel } 
					textReadingLevel={ this.props.book.lexile_score }  tooltipCopyType={ ReadingLevelIcon.TEACHER_VIEW }
					showImageOnly />
			)
		}
		if (this.state.edit) {
			var defaultValue = ReadingLevelFormat.getLexileScoreForFormat(this.props.lexile, this.props.format)
			var content = (<select ref="lexile" defaultValue={ defaultValue }  onChange={ this.handleChange }
						className="form-control selectOptions">
						{ DropDownOptions.Select.ReadingLevels({lexile_to_formats: this.props.format}) }
					</select>)
			return (
				<td className="">
					{ content }
				</td>
			);
		} else {
			var content = (
				<span className="readingLevelDisplay">
					<span className="level">{ level }</span> { icon }
				</span>
			)
			var link = (
				<Glyphicon icon={ "pencil" } className="editIcon"/>
			)
			return (
				<td className="clickable editable" onClick={this.triggerEdit}>
					{ content }
					{ link }
				</td>
			);
		}
	}
	renderInlineDisplay() {
		return (
			<span>
				{ ReadingLevelFormat.getScoreForFormat(this.props.lexile, this.props.format) }
			</span>
		);
	}
	render() {
		if (this.props.displayMode && this.props.displayMode == "cell") {
			return this.renderCellDisplay()
		} else {
			return this.renderInlineDisplay()
		}
	}
}

ReadingLevelDisplay.WrappedComponent.propTypes = StrictPropTypes({
	updateBook: PropTypes.func,
	lexile: PropTypes.number,
	format: PropTypes.string,
	book: PropTypes.object,
	displayMode: PropTypes.string,
	studentReadingLevel: PropTypes.number,
	showReadingLevelIcon: PropTypes.bool,
	userID: PropTypes.string,
});

var ORIGIN_TEXTS = {
	"TR": "Reading Level Diagnostic",
	"manual": "Manually Updated Reading Level"
}

ReadingLevelDisplay.ORIGIN_TEXTS = ORIGIN_TEXTS;

module.exports = ReadingLevelDisplay;


// WEBPACK FOOTER //
// ./modules/components/reading/reading_levels/ReadingLevelDisplay.js